module.exports = __webpack_public_path__ + "assets/cross.8fd10f17.svg";